import { useCallback } from 'react';

import { useTranslate } from '@src/core/hooks';

import { ATTRIBUTE_SLOT_I18N, PRODUCT_BOOKING_SLOT_I18N } from '../constants';
import { attributeTypeFromSlot, isAttributeSlot, type ProductBookingSlot } from '../types/productBookingSlot';
import { getAttributeTypeLabel } from '../core/attributes/getAttributeTypeLabel';

export const useSlotBlockTitle = () => {
  const { i18n } = useTranslate();

  return useCallback(
    (slot: ProductBookingSlot): string => {
      if (!isAttributeSlot(slot)) {
        return i18n(PRODUCT_BOOKING_SLOT_I18N[slot] as never);
      }

      const label = getAttributeTypeLabel(attributeTypeFromSlot(slot), (key) => i18n(key));

      return i18n(ATTRIBUTE_SLOT_I18N as never, { attribute: label.toLocaleLowerCase() });
    },
    [i18n],
  );
};
